import {GeneralStockModel} from "./generalstock.model";

export default class ChartModel
{
    _id: string | undefined;
    data: any[] = [];
    type: string | undefined = "";
    duration: string | undefined = "";
    interval: string | undefined = "";
    dataType: any[] = [];
    labels: string[] | undefined;
    colors: string[] | undefined;
    stocks: GeneralStockModel | undefined;
}